import { render, staticRenderFns } from "./riskNearmissAccident.vue?vue&type=template&id=28d20097"
import script from "./riskNearmissAccident.vue?vue&type=script&lang=js"
export * from "./riskNearmissAccident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d20097')) {
      api.createRecord('28d20097', component.options)
    } else {
      api.reload('28d20097', component.options)
    }
    module.hot.accept("./riskNearmissAccident.vue?vue&type=template&id=28d20097", function () {
      api.rerender('28d20097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskNearmissAccident.vue"
export default component.exports